module.exports = __webpack_public_path__ + "cancellara-dist/img/giftcard-header.ee7a8f52.jpg";